import { useState } from 'react';
import React from 'react';
import { CONFIG, api } from './_barrel.js';


        function AeaTrialUpload({ subjectId, token, onDone, compact }) {
            const [busy, setBusy] = useState(false);
            const [err, setErr] = useState(null);
            const inputRef = React.useRef(null);
            async function onFile(e) {
                const f = e.target.files && e.target.files[0];
                if (!f) return;
                setBusy(true); setErr(null);
                try {
                    const fd = new FormData();
                    fd.append('file', f);
                    fd.append('label', f.name);
                    const resp = await fetch(`${CONFIG.apiBase}/api/v1/aea/subjects/${subjectId}/trial`,
                        { method: 'POST', headers: { Authorization: `Bearer ${token}` }, body: fd });
                    if (!resp.ok) {
                        let msg = `Upload failed (${resp.status})`;
                        try { const j = await resp.json(); msg = j.detail || msg; } catch (_) {}
                        throw new Error(msg);
                    }
                    const data = await resp.json();
                    if (onDone) onDone(data.device_id);
                } catch (ex) { setErr(ex.message); }
                finally { setBusy(false); if (inputRef.current) inputRef.current.value = ''; }
            }
            return (
                <div className={compact ? '' : 'text-center'}>
                    {!compact && <div className="font-display text-xl gold mb-2">Trial with your own data</div>}
                    {!compact && <div className="text-sm text-muted mb-5" style={{ maxWidth: 560, margin: '0 auto 20px' }}>
                        No exposure is on file for this subject yet. Upload a location export for them — a
                        Google Timeline export, a Google Takeout <span className="font-mono">Records.json</span>,
                        a fitness <span className="font-mono">.gpx</span> track, geotagged photos
                        (a <span className="font-mono">.zip</span> or single image), or any CSV/JSON of positions —
                        and the engine will infer home, work and routine and grade the exposure. A consent record is
                        created and the file is stored as evidence.
                    </div>}
                    <input ref={inputRef} type="file" accept=".json,.csv,.xlsx,.gpx,.zip,.jpg,.jpeg,.heic,.tif,.tiff"
                           onChange={onFile} style={{ display: 'none' }} />
                    <button className="btn-gold" disabled={busy}
                            onClick={() => inputRef.current && inputRef.current.click()}>
                        {busy ? 'Analysing…' : (compact ? '+ Trial another export' : 'Upload location export')}
                    </button>
                    {err && <div className="text-sm mt-3" style={{ color: 'var(--red)' }}>{err}</div>}
                    {busy && <div className="text-xs text-muted mt-2">Ingesting, inferring places and grading — a large export can take a moment.</div>}
                </div>
            );
        }

export { AeaTrialUpload };
